import { CHANGE_CARD_REQUEST, SAVE_CARD, CLEAN_CARD } from '../constants/actionTypes';

const doChangeCreditCard = data => ({
  type: CHANGE_CARD_REQUEST,
  payload: data,
});

const doSaveCard = data => ({
  type: SAVE_CARD,
  payload: data,
});

const doCleanCard = data => ({
  type: CLEAN_CARD,
  payload: data,
})

export { doChangeCreditCard, doSaveCard, doCleanCard };
